import { render, staticRenderFns } from "./ChatInputButtons.vue?vue&type=template&id=7c771dc3&scoped=true&"
import script from "./ChatInputButtons.vue?vue&type=script&lang=js&"
export * from "./ChatInputButtons.vue?vue&type=script&lang=js&"
import style0 from "./ChatInputButtons.vue?vue&type=style&index=0&id=7c771dc3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c771dc3",
  null
  
)

export default component.exports